import * as types from './types';
import {
    apiGetSolutions,
    apiGetPrivacy,
    apiPostActivateVersion,
    apiPostPrivacy
} from 'app/components/routes/versions/api';

export const setSolutions = solutions => ( { type: types.VERSIONS__SET_SOLUTIONS, solutions } );
export const getSolutions = () => dispatch =>
    apiGetSolutions().then( results => {
        dispatch( setSolutions( results.solutions ) );
    } );

export const setVersionsList = ( id, list ) => ( {
    type: types.VERSIONS__SET_VERSIONS_LIST,
    id,
    list
} );
export const getVersions = solutionId => dispatch =>
    apiGetPrivacy( solutionId ).then( results => {
        dispatch( setVersionsList( solutionId, results.versions ) );
    } );
export const clearVersions = () => ( { type: types.VERSIONS__CLEAR_VERSIONS } );
export const createVersion = solutionId => dispatch =>
    apiPostPrivacy( solutionId ).then( results => {
        dispatch( { type: types.VERSIONS__CREATE_VERSIONS } );
        return results.id;
    } );
export const activateVersion = ( versionId, solutionId ) => dispatch =>
    apiPostActivateVersion( versionId ).then( () => dispatch( getVersions( solutionId ) ) );
